import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from "@emotion/styled";
import classNames from "classnames";
const StyledBox = styled("div")(({ style }) => ({ ...style }));
export function GrBox({ style, children, className, ...props }) {
    return (_jsx(StyledBox, { className: classNames("GrBox", className), style: style, ...props, children: children }));
}
//# sourceMappingURL=GrBox.js.map